import { getAllEquipos } from "../services";
import { useState, useRef } from "react";

const useEquipos = () => {
    const [equipos, setEquipos] = useState([]);
    const isFetchingRef = useRef(false);

    const fetchEquipos = async () => {
        if (isFetchingRef.current) {
            return;
        }
        
        try {
            isFetchingRef.current = true;
            const response = await getAllEquipos();
            let misDatos = formData(response);
            setEquipos(misDatos);
        } catch (error) {
            console.error("Error fetching equipos:", error);
        } finally {
            isFetchingRef.current = false;
        }
    }

    const formData = (datos) => {
        return datos.map((item) => ({
            id: item.id,
            nombre: item.nombre,
        }));
    }

    return {
        fetchEquipos,
        equipos
    };
}

export default useEquipos;